import React, { useState } from 'react'
import axios from 'axios'
import SideBar from '../../SideBar'
import { useEffect } from 'react'
import { ExcelExport } from '@progress/kendo-react-excel-export'
import { ExcelExportColumn } from '@progress/kendo-react-excel-export'
import { useLocation, Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Discount from './DiscountDialog'
import { FaRegEdit, FaRegTrashAlt } from 'react-icons/fa'
import HeaderName from '../../HeaderName'
const Income = () => {
  const token = localStorage.getItem('token')
  const url = process.env.REACT_APP_APP_URL
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  })

  const [origin, setOrigin] = useState(true)
  const [filterList, setFilterList] = useState([])
  const [showFilterList, setShowFilterList] = useState(false)
  const [disLists, setDisLists] = useState([])
  const [open, setOpen] = useState(false)
  const [close, setClose] = useState(false)
  const [showDialog, setShowDialog] = useState(false)
  const CreateDialog = () => {
    setOpen(true)
  }

  const handleUpdate = () => {
    Swal.fire({
      title: 'Wait',
      text: 'Not available yet!',
      icon: 'warning',
      confirmButtonText: 'CANCEL'
    })
  }

  const handleDelete = event => {
    console.log(event, 'ID')
    api
      .delete('item-discounts/' + event)
      .then(response => {
        Swal.fire({
          title: 'Success',
          text: 'Successfully Deleted!',
          icon: 'success',
          showConfirmButton: false,
          timer: 2000
        })
        const result = disLists.filter(item => item._id !== event)
        setDisLists(result)
      })
      .catch(error => {
        Swal.fire({
          title: 'Error',
          text: error.response.data.message,
          icon: 'error',
          confirmButtonText: 'CANCEL'
        })
      })
  }

  const handleNameFilter = event => {
    if (event) {
      setFilterList(
        disLists.filter(el =>
          el.name.toLowerCase().includes(event.toLowerCase())
        )
      )
      setShowFilterList(true)
      setOrigin(false)
    } else {
      setShowFilterList(false)

      setOrigin(true)
    }
  }
  useEffect(() => {
    const getDisReqLists = async () => {
      try {
        const res = await api.get('item-discounts')
        setDisLists(res.data.data)

        // setTreatmentLists(res.data.list)

        console.log(res.data.list, 'dis')
      } catch (err) {
        alert(err.message)
      }
    }
    getDisReqLists()
  }, [])

  return (
    <div classNameName='App'>
      <div className='wrapper'>
        <HeaderName />

        {/* <!-- /.navbar --> */}

        {/* <!-- Main Sidebar Container --> */}
        <SideBar />

        {/* <!-- Content Wrapper. Contains page content --> */}
        <div className='content-wrapper'>
          {/* <!-- Content Header (Page header) --> */}
          <div className='content-header'>
            <div className='container-fluid'>
              <div className='row mb-2'>
                <div className='col-sm-12'>
                  <ol className='breadcrumb'></ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}

          <section className='content'>
            <div className='container-fluid'>
              <div className='row d-flex justify-content-between '>
                <div className='col-md-6'>
                  {/* <h4>Medicine Item List</h4> */}
                </div>
                <div className='offset-1 col-md-4 ml-4'>
                  <div
                    className='input-group row'
                    style={{ marginBottom: '20px', marginLeft: '60px' }}
                  >
                    <div className='col-md-6'>
                      <input
                        type='search'
                        className='form-control rounded ml-1'
                        style={{ borderRadius: '12px' }}
                        onChange={e => handleNameFilter(e.target.value)}
                        id='search_code'
                        placeholder='Search'
                      />
                    </div>
                    <div className='col-md-6 mt-1'>
                      <button
                        onClick={CreateDialog}
                        className='btn'
                        style={{
                          borderRadius: '7px',
                          backgroundColor: 'black',
                          color: 'white'
                        }}
                      >
                        Create
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-12'>
                  <div className='card'>
                    <h5 className='card-header'>Discount List</h5>
                    {/* <div className="card-header">
                      <div className="row justify-content-between">
                        <span className="float-right">
                          <a href="/income_type" className="btn btn-primary">
                            Income Type
                          </a>
                           <button
                              type="button"
                              className="btn btn-primary"
                              onClick={excelExport}>
                              Export Excel
                            </button>
                        </span>
                      </div>
                      <div className="row" id="trial_balance"></div>
                    </div> */}

                    <div className='card-body'>
                      {/* Export data in Excel */}
                      {/* <ExcelExport data={incomeLists} ref={_export}>
                        <ExcelExportColumn
                          field=""
                          title="No"
                          locked={true}
                          width={30}
                        />
                        <ExcelExportColumn
                          field="date"
                          title="Date"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={200}
                        />

                        <ExcelExportColumn
                          field="relatedBankAccount.name"
                          title="Bank Account"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />

                        <ExcelExportColumn
                          field="relatedCashAccount.name"
                          title="Cash Account"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />

                        <ExcelExportColumn
                          field="relatedAccounting.name"
                          title="Account"
                          width={150}
                        />
                        <ExcelExportColumn
                          field="remark"
                          title="Remark"
                          width={150}
                        />
                      </ExcelExport> */}
                      {/* Export Data in Excel end */}
                      <div className='row'>
                        <div className='col-md-12'>
                          <div
                            className='table-responsive text-black'
                            id='slimtest2'
                          >
                            <table
                              className='table table-hover'
                              id='filter_date'
                            >
                              <thead>
                                <tr>
                                  <th>#</th>
                                  {/* <th>Start Date</th> */}
                                  {/* <th>End Date</th> */}

                                  <th>Discount Name</th>
                                  <th>Discount Type</th>
                                  <th>Expired Days</th>
                                  <th>Item Base Qty</th>

                                  <th>Discount Method</th>
                                  <th>Discount Value</th>
                                  {/* <th>Condition Type</th> */}
                                  {/* <th>Condition Type</th> */}

                                  {/* <th>Condition Value</th> */}
                                  <th className='text-center'>Action</th>
                                </tr>
                              </thead>
                              {origin && (
                                <tbody>
                                  {disLists.map((sq, i) => (
                                    <tr>
                                      <td>{++i}</td>


                                      <td>{sq ? sq.discountName : ''}</td>
                                      <td>{sq.discountType}</td>

                                      <td>{sq.expiredDay || 0}</td>
                                      <td>
                                        {sq.itemBase || 0}
                                      </td>

                                      <td>
                                        {sq?.discountRate}
                                      </td>
                                      <td>
                                        {sq?.discountRate === "Amount" ? sq?.discountValue : (sq?.discountValue + " %")}
                                      </td>

                                      <td className='text-center'>
                                        {/* <div>
                                        <UnitUpdate2 TreatId={TreatId} />
                                      </div> */}
                                        <Link
                                          to={'/dis-update/' + sq._id}
                                          className='btn btn-sm btn-warning'
                                        >
                                          <FaRegEdit />
                                        </Link>
                                        &nbsp;
                                        <button
                                          className='btn btn-sm btn-danger'
                                          onClick={e => handleDelete(sq._id)}
                                        >
                                          <FaRegTrashAlt />
                                        </button>
                                        &nbsp;
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              )}

                              {showFilterList && (
                                <tbody>
                                  {filterList.map((sq, i) => (
                                    <tr>
                                      <td>{++i}</td>
                                      <td>
                                        {sq.startDate
                                          ? sq.startDate.split('T')[0]
                                          : ''}
                                      </td>
                                      <td>
                                        {sq.endDate
                                          ? sq.endDate.split('T')[0]
                                          : ''}
                                      </td>

                                      <td>{sq ? sq.name : ''}</td>
                                      <td>{sq.type}</td>

                                      <td>{sq.value}</td>
                                      <td>
                                        {sq.relatedFOCID
                                          ? sq.relatedFOCID.name
                                          : ''}
                                      </td>

                                      {/* <td>
                                      {sq.conditionAmount ||
                                        sq.conditionPurchaseFreq ||
                                        sq.conditionPackageQty}
                                    </td> */}

                                      <td className='text-center'>
                                        {/* <div>
                                        <UnitUpdate2 TreatId={TreatId} />
                                      </div> */}
                                        <button
                                          onClick={handleUpdate}
                                          className='btn btn-sm btn-warning'
                                        >
                                          <FaRegEdit />
                                        </button>
                                        &nbsp;
                                        <button
                                          className='btn btn-sm btn-danger'
                                          onClick={e => handleDelete(sq._id)}
                                        >
                                          <FaRegTrashAlt />
                                        </button>
                                        &nbsp;
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              )}
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Discount
                open={open}
                close={() => setOpen(false)}
                setDisLists={setDisLists}
                disLists={disLists}
              />
            </div>
          </section>
        </div>
      </div>
      {/* <!-- /.content-wrapper --> */}
      <footer className='main-footer' style={{ marginTop: '50px;' }}>
        <strong>
          Copyright &copy; 2017-2020{' '}
          <a href='http://www.kwintechnologies.com'>K-win Technology</a>.
        </strong>
        All rights reserved.
      </footer>

      {/* <!-- Control Sidebar --> */}
      <aside className='control-sidebar control-sidebar-dark'>
        {/* <!-- Control sidebar content goes here --> */}
      </aside>

      {/* <!-- ./wrapper --> */}
    </div>
  )
}

export default Income
